const initialState={
    surveyData:[]
}

const surveyReducer = (state=initialState,action) => {
    switch (action.type) {
		case 'SURVEY-DATA':
			return {
				...state,
				surveyData: action.payload,
			};
		default:
			return {
				...state,
			};
	}
}

export default surveyReducer
